import { render, staticRenderFns } from "./AccountsExpansionPanelWrapper.vue?vue&type=template&id=25df71f8&scoped=true&"
import script from "./AccountsExpansionPanelWrapper.vue?vue&type=script&lang=js&"
export * from "./AccountsExpansionPanelWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AccountsExpansionPanelWrapper.vue?vue&type=style&index=0&id=25df71f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df71f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
